import { ITokenClasses } from "../Home/Token";

export default <ITokenClasses>{
  base: "token__section sm:mt-40 mt-[151px] flex flex-col items-center",
  image: "token_image mt-10 max-w-[40rem]",
  header: "",
  theader: "inter sm:text-3xl text-primary",
  details: "mb-10 relative",
  desc: "max-w-5xl py-3",
  lists: "list-disc inter",
  list: "text-[0.95rem] leading-6 py-1 ml-4",
  button: "font-normal px-0 py-0 !text-primary",
};
